/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Mobile_Referral_Referred_ByInputs */

const en_mobile_referral_referred_by = /** @type {(inputs: Mobile_Referral_Referred_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You already used referral code ${i?.code}.`)
};

const es_mobile_referral_referred_by = /** @type {(inputs: Mobile_Referral_Referred_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ya usaste el código de referido ${i?.code}.`)
};

/**
* | output |
* | --- |
* | "You already used referral code {code}." |
*
* @param {Mobile_Referral_Referred_ByInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_referred_by = /** @type {((inputs: Mobile_Referral_Referred_ByInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Referred_ByInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_referred_by(inputs)
	return en_mobile_referral_referred_by(inputs)
});